/* istanbul ignore file */
import * as yup from 'yup';
import { emailMsg, requiredMsg } from '../../../utils/validationMessages';

export const UserSchema = yup.object().shape({
  fullName: yup.string().required(requiredMsg('Full Name')),
  email: yup.string().email(emailMsg('Email')).required(requiredMsg('Email')),
  roleId: yup.number().required(requiredMsg('Role')),
});
